import type { AuthRepository, TokenPair } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';

export type RefreshSessionUseCase = UseCase<void, TokenPair>;

export function refreshSessionBuilder(authRepository: AuthRepository): RefreshSessionUseCase {
	return async function refreshSession(): Promise<TokenPair> {
		return authRepository.refresh();
	};
}
